import { Route, Routes } from 'react-router-dom';

import TemplateInvoice from './mau-hoa-don';
import DeclareRegisterInvoice from './to-khai-dang-ky';
import { PrivateRoute } from '../components/PrivateRoute';
import { ROLE } from '../../Constant';
import DeclareRegisterInvoiceND123 from './to-khai-dang-ki-nd123';
export default function Publish() {

  return (
    <Routes>
      <Route path="mau-hoa-don/*" element={<PrivateRoute role={ROLE.REGISTER_INVOICE}> <TemplateInvoice /></PrivateRoute>} />
      <Route path="to-khai-dang-ky-nd70/*" element={<PrivateRoute role={ROLE.DECLARE_REGISTER_INVOICE}> <DeclareRegisterInvoice /></PrivateRoute>} />
      <Route path="to-khai-dang-ky-nd123/*" element={<PrivateRoute role={ROLE.DECLARE_REGISTER_INVOICE}> <DeclareRegisterInvoiceND123 /></PrivateRoute>} />
    </Routes>
  );
}
